import axios from 'axios';
import ResourceAPI, { Resource, SearchParams } from 'api/ResourceAPI';
import { secureTokenStorage } from 'utils/secureTokenStorage';

export default class AIApiService {
  public static instance: AIApiService;

  public static baseUrl = process.env.REACT_APP_AI_API_URL;

  public static baseUrlCreate = 'ai-create-new-thread' as Resource;

  public static submitFeedbackUrl = 'ai-submit-feedback' as Resource;

  public static get Instance() {
    // eslint-disable-next-line no-return-assign
    return AIApiService.instance || (AIApiService.instance = new AIApiService());
  }

  public static async SendhQuery(data: any) {
    try {
      const idToken = secureTokenStorage.get()?.id_token ?? '';
      const res = await axios.post(`${this.baseUrl}`, data, {
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${idToken}`,
        },
      });

      const parsedData = res.data;
      return parsedData;
    } catch (error: unknown) {
      return null;
    }
  }

  public static async createThreadAI(payload: any) {
    try {
      const { data } = await ResourceAPI.post(this.baseUrlCreate, payload);
      return data;
    } catch (error: unknown) {
      return null;
    }
  }

  public static async submitFeedback(payload: any) {
    try {
      const { data } = await ResourceAPI.post(this.submitFeedbackUrl, payload);
      return data;
    } catch (error: unknown) {
      return null;
    }
  }
}
